/**
 * Sparkline SVG leve e sem dependências.
 * - 6 pontos, altura fixa 24px, largura fluida (100%).
 * - Pinta a linha na cor semântica passada (verde/vermelha/amarelo).
 * - Marca o último ponto com um circulozinho preenchido.
 */
export const Sparkline = ({ values = [], color = '#C5A059', height = 24 }) => {
  const filtered = values.filter((v) => typeof v === 'number');
  if (filtered.length < 2) {
    return (
      <div
        className="w-full text-[10px] text-slate-400 dark:text-slate-500 italic"
        style={{ height }}
      >
        aguardando histórico
      </div>
    );
  }

  const width = 100; // viewBox base
  const min = Math.min(...filtered);
  const max = Math.max(...filtered);
  const range = max - min || 1;
  const step = width / (filtered.length - 1);

  const points = filtered.map((v, i) => {
    const x = i * step;
    const y = height - 2 - ((v - min) / range) * (height - 4);
    return { x, y };
  });

  const path = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x.toFixed(2)} ${p.y.toFixed(2)}`).join(' ');
  const last = points[points.length - 1];

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      className="w-full block"
      style={{ height }}
      aria-hidden="true"
    >
      <path d={path} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={last.x} cy={last.y} r="1.8" fill={color} />
    </svg>
  );
};
